import { State } from "../state/state.interface";
export interface Company {
    id: number;
    company_name: string;
    email_id: string;
    gst_number: string;
    pan_number: string;
    bank_name_and_branch: string;
    bank_acount_number: string;
    ifsc_code: string;
    cheque_in_favour_of: string;
    contact_number: string;
    gst_percentage: number;
    address_1: string;
    address_2: string;
    city_id: number;
    state_id: number;
    pincode: string;
    state: State;
  };

export var displayColumns = [
  'company_name',
  'email_id',
]
export var displayHeaders = [
  'Name',
  'Email'
]

export var orderByColumns = [
  'company_name',
  'email_id',
]

export const filterParameters = [
    {
        name: 'created_at',
        type: 'date_range',
        operator: 'between',
        label: 'Select Date Range'
    },
    {
        name: 'company_name',
        type: 'string',
        operator: 'like',
        label: 'Company Name',
    },
    {
        name: 'gst_number',
        type: 'string',
        operator: 'like',
        label: 'GST Number',
    },
    {
        name: 'order_by_columns',
        type: 'multi_select',
        operator: 'order_by_columns',
        values: displayHeaders.map((header, index) => ({
                label: header,
                value: orderByColumns[index]
            })),
        model_name: 'company',
        label: 'Select columns for order by'
    }
];
